var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-layers',{on:{"layers":_vm.onBaseLayers}}),_vm._v(" "),_c('slopes-layers',{on:{"layers":_vm.onSlopesLayers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }